/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Bondsmith Savings Exchange Operation Portal APIs
 * OpenAPI spec version: 0.1
 */

/**
 * The tax wrapper to be applied to this instruction. Deposits in different tax wrappers are treated as distinct accounts
 */
export type TaxWrapper = typeof TaxWrapper[keyof typeof TaxWrapper];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TaxWrapper = {
  NONE: 'NONE',
  SIPP: 'SIPP',
} as const;
